import React from "react";

const FinalStep = ({ formData }) => {
  return (
    <div>
      <h3>Your registration details</h3>
      <p>Choice from Step 1: {formData.choice}</p>

      {/* Data display based on choice from Step1 and the data collected in Step2 */}
      {formData.choice === "option1" && (
        <>
          <p>Age Option: {formData.ageOption}</p>
          {formData.ageOption === "yes" && (
            <p>I confirm that I am 18 years or over.</p>
          )}
          {formData.ageOption === "no" && (
            <p>I will have my guardian as the account holder.</p>
          )}
        </>
      )}
      {formData.choice === "option2" && (
        <>
          <p>First Name: {formData.firstName}</p>
          <p>Last Name: {formData.lastName}</p>
        </>
      )}
      {/* ... other form data points ... */}
      <button>Submit</button>
    </div>
  );
};

export default FinalStep;
